var map = {
	"./cn.json": 9055,
	"./de.json": 441,
	"./es.json": 3270,
	"./fr.json": 9406,
	"./jp.json": 2256,
	"./kr.json": 339,
	"./languages.json": 8605,
	"./pt.json": 4482,
	"./ru.json": 3399,
	"./us.json": 6422,
	"./vn.json": 9722,
	"./zh.json": 6472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1893;